import {Injectable} from '@angular/core';
import {FascicoloFull} from '../../../common/models/fascicolo/fascicolo-full';
import {RowSezione} from '../../../common/models/fascicolo/row-sezione';
import {VoceSezione} from '../../../common/models/fascicolo/voce-sezione';
import {FormAmiantoGiudizialeComponent} from '../form-amianto-giudiziale/form-amianto-giudiziale.component';
import {
  FormAmiantoGiudizialeViewComponent
} from '../form-amianto-giudiziale/view/form-amianto-giudiziale-view.component';
import {FormAmiantoComponent} from '../form-amianto/form-amianto.component';
import {FormAmiantoViewComponent} from '../form-amianto/view/form-amianto-view.component';
import {FormAppelloComponent} from '../form-appello/form-appello.component';
import {FormAppelloViewComponent} from '../form-appello/view/form-appello-view.component';
import {FormArbitratoComponent} from '../form-arbitrato/form-arbitrato.component';
import {FormArbitratoViewComponent} from '../form-arbitrato/view/form-arbitrato-view.component';
import {FormAzioneMonitoriaComponent} from '../form-azione-monitoria/form-azione-monitoria.component';
import {FormAzioneMonitoriaViewComponent} from '../form-azione-monitoria/view/form-azione-monitoria-view.component';
import {FormCautelareComponent} from '../form-cautelare/form-cautelare.component';
import {FormCautelareViewComponent} from '../form-cautelare/view/form-cautelare-view.component';
import {
  FormConciliazioneStragiudizialeComponent
} from '../form-conciliazione-stragiudiziale/form-conciliazione-stragiudiziale.component';
import {
  FormConciliazioneStragiudizialeViewComponent
} from '../form-conciliazione-stragiudiziale/view/form-conciliazione-stragiudiziale-view.component';
import {FormCoterziComponent} from '../form-coterzi/form-coterzi.component';
import {FormCoterziViewComponent} from '../form-coterzi/view/form-coterzi-view.component';
import {FormEsecuzioneComponent} from '../form-esecuzione/form-esecuzione.component';
import {FormEsecuzioneViewComponent} from '../form-esecuzione/view/form-esecuzione-view.component';
import {FormImmobiliareComponent} from '../form-immobiliare/form-immobiliare.component';
import {FormImmobiliareViewComponent} from '../form-immobiliare/view/form-immobiliare-view.component';
import {FormMobiliareComponent} from '../form-mobiliare/form-mobiliare.component';
import {FormMobiliareViewComponent} from '../form-mobiliare/view/form-mobiliare-view.component';
import {
  FormOpposizioneDecretoIngiuntivoComponent
} from '../form-opposizione-decreto-ingiuntivo/form-opposizione-decreto-ingiuntivo.component';
import {
  FormOpposizioneDecretoIngiuntivoViewComponent
} from '../form-opposizione-decreto-ingiuntivo/view/form-opposizione-decreto-ingiuntivo-view.component';
import {FormOrdinarioComponent} from '../form-ordinario/form-ordinario.component';
import {FormOrdinarioViewComponent} from '../form-ordinario/view/form-ordinario-view.component';
import {FormPrecettoComponent} from '../form-precetto/form-precetto.component';
import {FormPrecettoViewComponent} from '../form-precetto/view/form-precetto-view.component';
import {FormPrevidenzialeComponent} from '../form-previdenziale/form-previdenziale.component';
import {FormPrevidenzialeViewComponent} from '../form-previdenziale/view/form-previdenziale-view.component';
import {
  FormRecuperoCreditiStragiudizialeComponent
} from '../form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from '../form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component';
import {FormRicorsoCassazioneComponent} from '../form-ricorso-cassazione/form-ricorso-cassazione.component';
import {
  FormRicorsoCassazioneViewComponent
} from '../form-ricorso-cassazione/view/form-ricorso-cassazione-view.component';
import {FormRicorsoLavoroComponent} from '../form-ricorso-lavoro/form-ricorso-lavoro.component';
import {FormRicorsoLavoroViewComponent} from '../form-ricorso-lavoro/view/form-ricorso-lavoro-view.component';
import {FormRicorsoOpposizioneComponent} from '../form-ricorso-opposizione/form-ricorso-opposizione.component';
import {
  FormRicorsoOpposizioneViewComponent
} from '../form-ricorso-opposizione/view/form-ricorso-opposizione-view.component';
import {FormRicorsoAmministrativoComponent} from '../form-ricorso/form-ricorso.component';
import {FormRicorsoAmministrativoViewComponent} from '../form-ricorso/view/form-ricorso-view.component';
import {FormRitoForneroComponent} from '../form-rito-fornero/form-rito-fornero.component';
import {FormRitoForneroViewComponent} from '../form-rito-fornero/view/form-rito-fornero-view.component';
import {FormSpecialeComponent} from '../form-speciale/form-speciale.component';
import {FormSpecialeViewComponent} from '../form-speciale/view/form-speciale-view.component';
import {
  FormTentativoObbligatorioConciliazioneComponent
} from '../form-tentativo-obbligatorio-conciliazione/form-tentativo-obbligatorio-conciliazione.component';
import {
  FormTentativoObbligatorioConciliazioneViewComponent
} from '../form-tentativo-obbligatorio-conciliazione/view/form-tentativo-obbligatorio-conciliazione-view.component';
import {FascicoloAmiantoGiudiziale} from '../models/amianto-giudiziale/fascicolo-amianto-giudiziale';
import {FascicoloAmianto} from '../models/amianto/fascicolo-amianto';
import {FascicoloAppello} from '../models/appello/fascicolo-appello';
import {FascicoloArbitrato} from '../models/arbitrato/fascicolo-arbitrato';
import {FascicoloAzioneMonitoria} from '../models/azione-monitoria/fascicolo-azione-monitoria';
import {FascicoloCautelare} from '../models/cautelare/fascicolo-cautelare';
import {
  FascicoloConciliazioneStragiudiziale
} from '../models/conciliazione-stragiudiziale/fascicolo-conciliazione-stragiudiziale';
import {FascicoloCoTerzi} from '../models/coterzi/fascicolo-coterzi';
import {FascicoloEsecuzione} from '../models/esecuzione/fascicolo-esecuzione';
import {FascicoloImmobiliare} from '../models/immobiliare/fascicolo-immobiliare';
import {FascicoloMobiliare} from '../models/mobiliare/fascicolo-mobiliare';
import {
  FascicoloOpposizioneDecretoIngiuntivo
} from '../models/opposizione-decreto-ingiuntivo/fascicolo-opposizione-decreto-ingiuntivo';
import {FascicoloOrdinario} from '../models/ordinario/fascicolo-ordinario';
import {FascicoloPrecetto} from '../models/precetto/fascicolo-precetto';
import {FascicoloPrevidenziale} from '../models/previdenziale/fascicolo-previdenziale';
import {
  FascicoloRecuperoCreditiStragiudiziale
} from '../models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale';
import {FascicoloRicorsoAmministrativo} from '../models/ricorso-amministrativo/fascicolo-ricorso-amministrativo';
import {FascicoloRicorsoCassazione} from '../models/ricorso-cassazione/fascicolo-ricorso-cassazione';
import {FascicoloRicorsoLavoro} from '../models/ricorso-lavoro/fascicolo-ricorso-lavoro';
import {FascicoloRicorsoOpposizione} from '../models/ricorso-opposizione/fascicolo-ricorso-opposizione';
import {FascicoloRitoFornero} from '../models/rito-fornero/fascicolo-rito-fornero';
import {FascicoloSpeciale} from '../models/speciale/fascicolo-speciale';
import {
  FascicoloTentativoObbligatorioConciliazione
} from '../models/tentativo-obbligatorio-conciliazione/fascicolo-tentativo-obbligatorio-conciliazione';
import {
  FormNegoziazioneAssistitaViewComponent
} from '../form-negoziazione-assistita/view/form-negoziazione-assistita-view.component';
import {FormNegoziazioneAssistitaComponent} from '../form-negoziazione-assistita/form-negoziazione-assistita.component';
import {FascicoloNegoziazioneAssistita} from '../models/negoziazione-assistita/fascicolo-negoziazione-assistita';
import {FascicoloGenerico} from '../models/generico/fascicolo-generico';
import {FormGenericoViewComponent} from '../form-generico/view/form-generico-view.component';
import {FormGenericoComponent} from '../form-generico/form-generico.component';

@Injectable({
  providedIn: 'root',
})
export class FascicoloService {
  constructor() {
  }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'amianto': {
        fascicolo = new FascicoloAmianto();
        break;
      }
      case 'amiantogiudiziale': {
        fascicolo = new FascicoloAmiantoGiudiziale();
        break;
      }
      case 'appello': {
        fascicolo = new FascicoloAppello();
        break;
      }
      case 'arbitrato': {
        fascicolo = new FascicoloArbitrato();
        break;
      }
      case 'azionemonitoria': {
        fascicolo = new FascicoloAzioneMonitoria();
        break;
      }
      case 'opposizionedecretoingiuntivo': {
        fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
        break;
      }
      case 'ricorsocassazione': {
        fascicolo = new FascicoloRicorsoCassazione();
        break;
      }
      case 'opposizione': {
        fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
      }
      case 'ricorsolavoro':
      case 'ricorso': {
        fascicolo = new FascicoloRicorsoLavoro();
        break;
      }
      case 'ricorsoopposizione': {
        fascicolo = new FascicoloRicorsoOpposizione();
        break;
      }
      case 'ritofornero': {
        fascicolo = new FascicoloRitoFornero();
        break;
      }
      case 'tentativoobbligatorioconciliazione': {
        fascicolo = new FascicoloTentativoObbligatorioConciliazione();
        break;
      }
      case 'cautelare': {
        fascicolo = new FascicoloCautelare();
        break;
      }
      case 'esecuzionepressoterzi': {
        fascicolo = new FascicoloCoTerzi();
        break;
      }
      case 'esecuzioneimmobiliare': {
        fascicolo = new FascicoloImmobiliare();
        break;
      }
      case 'esecuzionemobiliare': {
        fascicolo = new FascicoloMobiliare();
        break;
      }
      case 'esecuzione': {
        fascicolo = new FascicoloEsecuzione();
        break;
      }
      case 'ordinario': {
        fascicolo = new FascicoloOrdinario();
        break;
      }
      case 'precetto': {
        fascicolo = new FascicoloPrecetto();
        break;
      }
      case 'recuperocreditistragiudiziale': {
        fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
        break;
      }
      case 'previdenziale': {
        fascicolo = new FascicoloPrevidenziale();
        break;
      }
      case 'speciale': {
        fascicolo = new FascicoloSpeciale();
        break;
      }
      case 'conciliazione': {
        fascicolo = new FascicoloConciliazioneStragiudiziale();
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        fascicolo = new FascicoloRicorsoAmministrativo();
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        fascicolo = new FascicoloRicorsoAmministrativo();
        break;
      }
      case 'negoziazione': {
        fascicolo = new FascicoloNegoziazioneAssistita();
        break;
      }
      case 'genericogiudiziale': {
        fascicolo = new FascicoloGenerico();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;
    switch (idFormTenant) {
      case 'LavAmi_PRD': {
        component = view ? FormAmiantoViewComponent : FormAmiantoComponent;
        break;
      }
      case 'LavAmg_PRD': {
        component = view
          ? FormAmiantoGiudizialeViewComponent
          : FormAmiantoGiudizialeComponent;
        break;
      }
      case 'LavApp_PRD': {
        component = view ? FormAppelloViewComponent : FormAppelloComponent;
        break;
      }
      case 'LavArb_PRD': {
        component = view ? FormArbitratoViewComponent : FormArbitratoComponent;
        break;
      }
      case 'LavAzi_PRD': {
        component = view
          ? FormAzioneMonitoriaViewComponent
          : FormAzioneMonitoriaComponent;
        break;
      }
      case 'LavOdi_PRD': {
        component = view
          ? FormOpposizioneDecretoIngiuntivoViewComponent
          : FormOpposizioneDecretoIngiuntivoComponent;
        break;
      }
      case 'LavOpp_PRD': {
        component = view
          ? FormOpposizioneDecretoIngiuntivoViewComponent
          : FormOpposizioneDecretoIngiuntivoComponent;
        break;
      }
      case 'LavOpp_PRD': {
        component = view ? FormOpposizioneDecretoIngiuntivoViewComponent : FormOpposizioneDecretoIngiuntivoComponent;
        break;
      }
      case 'LavRca_PRD': {
        component = view
          ? FormRicorsoCassazioneViewComponent
          : FormRicorsoCassazioneComponent;
        break;
      }
      case 'LavRla_PRD': {
        component = view
          ? FormRicorsoLavoroViewComponent
          : FormRicorsoLavoroComponent;
        break;
      }
      case 'LavRop_PRD': {
        component = view
          ? FormRicorsoOpposizioneViewComponent
          : FormRicorsoOpposizioneComponent;
        break;
      }
      case 'LavRfo_PRD': {
        component = view
          ? FormRitoForneroViewComponent
          : FormRitoForneroComponent;
        break;
      }
      case 'LavToc_PRD': {
        component = view
          ? FormTentativoObbligatorioConciliazioneViewComponent
          : FormTentativoObbligatorioConciliazioneComponent;
        break;
      }
      case 'LavCau_PRD': {
        component = view ? FormCautelareViewComponent : FormCautelareComponent; // "CAUTELARE";
        break;
      }
      case 'LavOrd_PRD': {
        component = view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
        break;
      }
      case 'LavSpe_PRD': {
        component = view ? FormSpecialeViewComponent : FormSpecialeComponent; // "SPECIALE";
        break;
      }
      case 'LavEim_PRD': {
        component = view
          ? FormImmobiliareViewComponent
          : FormImmobiliareComponent; // "ESECUZIONE IMMOBILIARE";
        break;
      }
      case 'LavEmo_PRD': {
        component = view ? FormMobiliareViewComponent : FormMobiliareComponent; // "ESECUZIONE MOBILIARE";
        break;
      }
      case 'LavEpt_PRD': {
        component = view ? FormCoterziViewComponent : FormCoterziComponent; // "ESECUZIONE C/O TERZI";
        break;
      }
      case 'LavPre_PRD': {
        component = view ? FormPrecettoViewComponent : FormPrecettoComponent; // "PRECETTO";
        break;
      }
      case 'LavRec_PRD': {
        component = view
          ? FormRecuperoCreditiStragiudizialeViewComponent
          : FormRecuperoCreditiStragiudizialeComponent; // "RECUPERO CREDITI STRAGIUDIZIALE";
        break;
      }
      case 'LavPrev_PRD': {
        component = view
          ? FormPrevidenzialeViewComponent
          : FormPrevidenzialeComponent;
        break;
      }
      case 'LavEse_PRD': {
        component = view
          ? FormEsecuzioneViewComponent
          : FormEsecuzioneComponent;
        break;
      }
      case 'LavCon_PRD': {
        component = view
          ? FormConciliazioneStragiudizialeViewComponent
          : FormConciliazioneStragiudizialeComponent;
        break;
      }
      case 'LavRam_PRD': {
        component = view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent; // "RICORSO AMMINISTRATIVO";
        break;
      }
      case 'LavRam_PRD': {
        component = view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent; // "RICORSO AMMINISTRATIVO";
        break;
      }
      case 'LavNeg_PRD': {
        component = view ? FormNegoziazioneAssistitaViewComponent : FormNegoziazioneAssistitaComponent; // "NEGOZIAZIONE ASSISTITA";
        break;
      }
      case 'LavGen_PRD': {
        component = view ? FormGenericoViewComponent : FormGenericoComponent; // "GENERICO";
        break;
      }
    }
    return component;
  }

  // ONLY FOR AMIANTO AND AMIANTO GIUDIZIALE (SHOW SAME NAME) - UNUSED
  /*getFascicoloFromUrl(route): string {
    let nameFascicolo;
    const segmentsArray = route.root.children.primary.segments;
    if (segmentsArray.findIndex(el => el.path === UrlSettingsCore.NOME_FASCICOLO_FRONT_END_AMIANTO_LAVORO) > -1) {
      nameFascicolo = UrlSettingsCore.NOME_FASCICOLO_FRONT_END_AMIANTO_LAVORO;
    }
    if (segmentsArray.findIndex(el => el.path === UrlSettingsCore.NOME_FASCICOLO_FRONT_END_AMIANTO_GIUDIZIALE_LAVORO) > -1) {
      nameFascicolo = UrlSettingsCore.NOME_FASCICOLO_FRONT_END_AMIANTO_GIUDIZIALE_LAVORO;
    }
    return nameFascicolo;
  }*/

  getMappaCopertinaFascicolo(
    genericFascicolo: string,
    fascicolo: FascicoloFull,
    viewComponentDynamic: string, assegnatario?: string
  ): RowSezione[] {
    let esiti =  this.getEsitiFromCopertina(fascicolo);
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    switch (genericFascicolo) {
      case 'amianto': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          /*new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),*/
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(              
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'amiantogiudiziale':
      case 'genericogiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'appello': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'arbitrato': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'text', 'Tipo arbitrato', fascicolo.copertina.campi.tipoArbitrato),
            new VoceSezione(6, 'date', 'Data richiesta arbitrato', fascicolo.copertina.campi.dataRichiestaArbitrato),
            /*new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi),*/
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
         new RowSezione('Arbitri - Collegio arbitrale', [
            new VoceSezione(12, 'text', 'Arbitri', fascicolo.copertina.campi.listaArbitri),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'azionemonitoria': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero decreto ingiuntivo', fascicolo.copertina.campi.numeroDecretoIngiuntivo)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'opposizionedecretoingiuntivo': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(
              4,
              'text',
              'Posizione fascicolo',
              fascicolo.copertina.campi.posizioneFascicoloRif
            ),
            new VoceSezione(
              4,
              'text',
              'N&deg; ruolo/decreto',
              fascicolo.copertina.campi.numRuoloDecretoRif
            ),
            new VoceSezione(
              4,
              'text',
              'Motivo opposizione',
              fascicolo.copertina.campi.motivoOpposizione
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'opposizione': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(
              4,
              'text',
              'Posizione fascicolo',
              fascicolo.copertina.campi.posizioneFascicoloRif
            ),
            new VoceSezione(
              4,
              'text',
              'N&deg; ruolo/decreto',
              fascicolo.copertina.campi.numRuoloDecretoRif
            ),
            new VoceSezione(
              4,
              'text',
              'Motivo opposizione',
              fascicolo.copertina.campi.motivoOpposizione
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'opposizione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(4, 'text', 'Posizione fascicolo', fascicolo.copertina.campi.posizioneFascicoloRif),
            new VoceSezione(4, 'text', 'N&deg; ruolo/decreto', fascicolo.copertina.campi.numRuoloDecretoRif),
            new VoceSezione(4, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(6, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(6, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsocassazione': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'ricorso':
      case 'ricorsolavoro': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsoopposizione': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Opposizione', [
            new VoceSezione(
              12,
              'text',
              'Motivo opposizione',
              fascicolo.copertina.campi.motivoOpposizione
            ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'ritofornero': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'tentativoobbligatorioconciliazione': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
            new VoceSezione(
              4,
              'boolean',
              'Fondo rischi',
              fascicolo.copertina.campi.fondoRischi
            ),*/
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              4,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Direzione territoriale lavoro',
              fascicolo.copertina.campi.direzioneTerritorialeLavoro
            ),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'cautelare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'esecuzionepressoterzi': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Terzi pignorati', [
            new VoceSezione(12, 'text', 'Soggetti terzi pignorati', fascicolo.copertina.campi.listaTerziPignorati
            ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'esecuzioneimmobiliare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'esecuzionemobiliare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'esecuzione': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'ordinario': {
        return [
          new RowSezione(null, [
            new VoceSezione(
              3,
              'text',
              'Posizione',
              fascicolo.copertina.campi.identificativoFascicolo
            ),
            new VoceSezione(
              3,
              'text',
              'Vecchia posizione',
              fascicolo.vecchiaPosizione
            ),
            new VoceSezione(
              3,
              'text',
              'Tipo Fascicolo',
              fascicolo.copertina.campi.tipo
            ),
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'date',
              'Data apertura fascicolo',
              fascicolo.copertina.campi.dataInizioFascicolo
            ),
            new VoceSezione(
              4,
              'date',
              'Data ultima modifica',
              fascicolo.copertina.campi.dataUltimaModifica
            ),
            new VoceSezione(
              4,
              'text',
              'Stato',
              fascicolo.copertina.campi.stato
            ),
          ]),
          new RowSezione(null, [
            new VoceSezione(
              6,
              'date',
              'Data definizione',
              fascicolo.copertina.campi.dataDefinizione
            ),
            new VoceSezione(
              6,
              'text',
              'Motivo definizione',
              fascicolo.copertina.campi.motivoDefinizione
            ),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? 'Riunione dei giudizi'
              : '',
            fascicolo.copertina.campi.capofila ||
            fascicolo.copertina.campi.riunito
              ? [
                new VoceSezione(
                  4,
                  'text',
                  fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito',
                  'Si'
                ),
                new VoceSezione(
                  4,
                  'date',
                  'Data riunione giudizio',
                  fascicolo.copertina.campi.dataRiunioneGiudizio
                ),
                new VoceSezione(
                  4,
                  'text',
                  'Motivo riunione giudizio',
                  fascicolo.copertina.campi.motivoRiunioneGiudizio
                ),
              ]
              : [new VoceSezione(12, '', '', '')]
          ),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Parte primaria (n. controparti)',
              fascicolo.copertina.campi.contropartePrimaria +
              (' (' + fascicolo.copertina.campi.numeroControparti + ')')
            ),
            /*new VoceSezione(
              4,
              'text',
              'Legale incaricato',
              (fascicolo.copertina.campi.legaleIncaricato
                ? fascicolo.copertina.campi.legaleIncaricato
                : '') +
              (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato
                ? ' (' +
                fascicolo.copertina.campi.tipologiaDiLegaleIncaricato +
                ')'
                : '')
            ),*/
            new VoceSezione(
              4,
              'text',
              'Assegnatario',
              assegnatario
            ),
            new VoceSezione(
              4,
              'text',
              'Visibilità',
              fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null)
            )
          ]),
          new RowSezione(null, [
            new VoceSezione(
              4,
              'text',
              'Numero/anno ruolo',
              (fascicolo.copertina.campi.numeroRuolo
                ? fascicolo.copertina.campi.numeroRuolo
                : '') +
              (fascicolo.copertina.campi.numeroRuolo &&
              fascicolo.copertina.campi.annoRuolo
                ? '/'
                : '') +
              (fascicolo.copertina.campi.annoRuolo
                ? fascicolo.copertina.campi.annoRuolo
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Autorit&agrave; giudiziaria',
              (fascicolo.copertina.campi.autoritaGiudiziaria
                ? fascicolo.copertina.campi.autoritaGiudiziaria
                : '') +
              (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null
                ? ' di ' + fascicolo.copertina.campi.sedeAutoritaGiudiziaria
                : '')
            ),
            new VoceSezione(
              4,
              'text',
              'Valore',
              fascicolo.copertina.campi.valore
            ),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(
              12,
              'text',
              'Gruppi competenti',
              fascicolo.copertina.campi.competenza
            ),
          ]),
        ];
        break;
      }
      case 'precetto': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            // new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Numero decreto ingiuntivo riferimento', fascicolo.copertina.campi.numeroDecretoIngiuntivoRif),
            new VoceSezione(4, 'importo', 'Valore decreto ingiuntivo riferimento', fascicolo.copertina.campi.valoreDecretoIngiuntivoRif),
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'recuperocreditistragiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            // new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Numero decreto ingiuntivo riferimento', fascicolo.copertina.campi.numeroDecretoIngiuntivoRif),
            new VoceSezione(4, 'importo', 'Valore decreto ingiuntivo riferimento', fascicolo.copertina.campi.valoreDecretoIngiuntivoRif),
          ]),
          new RowSezione('Diffida', [
            new VoceSezione(4, 'text', 'Ultima lettera diffida (numero invii)', fascicolo.copertina.campi.tipoUltimaLetteraDiffida ? fascicolo.copertina.campi.tipoUltimaLetteraDiffida + ' (' + (fascicolo.copertina.campi.numeroInviiDiffida ? fascicolo.copertina.campi.numeroInviiDiffida : '0') + ')' : ''),
            new VoceSezione(4, 'date', 'Data ultima diffida', fascicolo.copertina.campi.dataUltimaLetteraDiffida),
            new VoceSezione(4, 'text', 'Esito ultimo invio', fascicolo.copertina.campi.esitoUltimoInvioDiffida),
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'previdenziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'speciale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'conciliazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Ultima udienza',
            //   fascicolo.copertina.campi.ultimaUdienza
            // ),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(
              6,
              'date',
              'Prossima udienza',
              fascicolo.copertina.campi.prossimaUdienza
            ),
            // new VoceSezione(
            //   4,
            //   'date',
            //   'Prossima scadenza',
            //   fascicolo.copertina.campi.prossimaScadenza
            // ),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza),
          ]),
        ];
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'negoziazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione('Negoziazione', [
            new VoceSezione(4, 'text', 'Tipo negoziazione', fascicolo.copertina.campi.tipoNegoziazione),
            new VoceSezione(4, 'date', 'Data invio invito', fascicolo.copertina.campi.dataInvito),
            new VoceSezione(4, 'date', 'Data termine concordato', fascicolo.copertina.campi.dataTermineConcordato)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }

  getEsitiFromCopertina(fascicolo: FascicoloFull): any[]{
    let listaVoci = [];
    if (fascicolo.copertina.campi.esiti) {
      for (let esito of fascicolo.copertina.campi.esiti) {
        listaVoci.push(new VoceSezione(3, "text", "Esito", esito.esitoPerSocieta));
        listaVoci.push(new VoceSezione(3, "text", "Tipo", esito.tipoSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Numero/Anno", esito.numeroSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Risoluzione per parte", esito.esitoRisoluzioneParte));
      }
    }
    return listaVoci;
  }

  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];
    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }
     
    return listaVoci;
  }
}
